import { Models } from 'api'

export const LOGIN_URL = `https://${process.env.BL_API_HOST}/user/portal`

export interface AuthInfo {
  user: Models.Farmer
}
